import template from './averageLoanSize.html';
import controller from './averageLoanSizeCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    myParam: '<',
  },
};
